import { useEffect } from 'react';
import { User, X, Gift, Trophy, Clock, Play, Eye } from 'lucide-react';

// Modale de détail d'un code catégorie : sessions du participant (statut, score, temps).
// onReviewChild (optionnel) : affiche un bouton « voir la session » sur les quiz terminés.
export default function CategoryCodeDetailModal({ item, onClose, onReviewChild }) {
    useEffect(() => {
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handleKey);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleKey);
            document.body.style.overflow = '';
        };
    }, [onClose]);

    if (!item) return null;
    const pct = item.total_points > 0 ? Math.round((item.total_score / item.total_points) * 100) : null;

    return (
        <div className="ccp-overlay" onClick={onClose}>
            <div className="ccp-modal ccp-modal--detail" onClick={e => e.stopPropagation()}>
                <div className="ccp-header">
                    <User size={16} />
                    <span className="ccp-title">
                        {item.participant_name || '(participant non défini)'} — {item.category_label}
                    </span>
                    <button className="ccp-close" onClick={onClose}><X size={18} /></button>
                </div>
                <div className="ccp-detail-meta">
                    <span className="ccp-chip">{item.code}</span>
                    <span className="ccp-chip">Mode : {item.mode === 'apprentissage' ? 'Apprentissage' : 'Quiz'}</span>
                    {!!Number(item.is_gift) && <span className="ccp-chip ccp-chip--gift"><Gift size={11} /> Offert</span>}
                    <span className="ccp-chip">
                        {item.nb_finished}/{item.nb_total} terminés
                        {item.total_points > 0 && <> — {item.total_score}/{item.total_points} ({pct}%)</>}
                    </span>
                </div>
                {(item.children || []).length === 0 ? (
                    <div className="ccp-empty" style={{ margin: '16px 0' }}>
                        Aucune session démarrée pour le moment.
                    </div>
                ) : (
                    <div className="ccp-child-list">
                        {item.children.map(ch => {
                            const chPct = ch.total > 0 ? Math.round((ch.score / ch.total) * 100) : null;
                            return (
                                <div key={ch.sous_sujet_id} className={`ccp-child ccp-child--${ch.status.toLowerCase()}`}>
                                    <div className="ccp-child-icon">
                                        {ch.status === 'FINISHED' ? <Trophy size={16} />
                                            : ch.status === 'IN_PROGRESS' ? <Clock size={16} />
                                            : <Play size={16} />}
                                    </div>
                                    <div className="ccp-child-body">
                                        <div className="ccp-child-title">{ch.sous_sujet_label}</div>
                                        <div className="ccp-child-meta">
                                            <span>{ch.mode === 'apprentissage' ? 'Apprentissage' : 'Quiz'}</span>
                                            {ch.status === 'FINISHED' && (
                                                <>
                                                    <span>·</span>
                                                    <span className="ccp-child-score">{ch.score}/{ch.total} · {chPct}%</span>
                                                    <span>·</span>
                                                    <span>{Math.round((ch.time_in_seconds || 0) / 60)} min</span>
                                                    <span>·</span>
                                                    <span>{new Date(ch.finished_at).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}</span>
                                                </>
                                            )}
                                            {ch.status === 'IN_PROGRESS' && ch.started_at && (
                                                <>
                                                    <span>·</span>
                                                    <span>Débuté le {new Date(ch.started_at).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    {onReviewChild && ch.status === 'FINISHED' && ch.id && (
                                        <button className="share-panel__code-copy" onClick={() => onReviewChild(ch)} title="Voir la session complète" style={{ flexShrink: 0 }}>
                                            <Eye size={14} />
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
